/*
 * Module for handling a single category and its data
 */

define([
  "marionette",
  "messaging/messenger",
  "./categoryInfoView",
  "./categoryName/categoryNameModule",
  "./categoryName/categoryNameView",
  "./categoryNamesLocalized/categoryNamesLocalizedModule",
  "./categoryDescription/categoryDescriptionModule",
  "modules/authoringAdmin/categories/category/topicsUsingCategoryModal/topicsUsingCategoryListModel",
  "modules/authoringAdmin/categories/category/topicsUsingCategoryModal/topicsUsingCategoryModalModule",
], function (
  Marionette,
  Messenger,
  CategoryInfoView,
  CategoryNameModule,
  CategoryNameView,
  CategoryNamesLocalizedModule,
  CategoryDescriptionModule,
  TopicsUsingCategoryModel,
  TopicsUsingCategoryModalModule,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "categoryInfo";
      this.region = options.region;
      this.category = options.model;
    },
    show: function () {
      this.layout = new CategoryInfoView.categoryInfoLayout({ model: this.category });
      this.selectedLanguage = Messenger.reqres.request("kb:selected:language");
      this.selectedLanguageId = this.selectedLanguage.get("id");
      this.category.selectedLanguage = this.selectedLanguage;
      this.category.selectedLanguageId = this.selectedLanguageId;

      Messenger.vent.on(
        "change:kb:selected:language:info",
        function (selectedLanguage) {
          if (!this.category.get("categoryName") || this.category.get("categoryName") === "") {
            //default locale categoryName is empty
            if (selectedLanguage.get("id") !== 0) {
              //do nothing
            }
          } else {
            this.changeModule(selectedLanguage);
          }
        },
        this,
      );

      this.layout.on(
        "toggle:unfilterable",
        function () {
          this.category.set("unfilterable", !this.category.get("unfilterable"));
          this.layout.render();
          this.changeModule(this.selectedLanguage);
        },
        this,
      );

      this.layout.on(
        "delete:category",
        function (args) {
          let catId = args.model.get("categoryId");
          const kbId = Messenger.reqres.request("active:kb");
          this.topicsUsingCategory = Messenger.reqres.request(
            "fetch:topics:using:category",
            kbId,
            catId,
            null,
          );
          this.topicsUsingCategory.onSynced(() => {
            if (this.topicsUsingCategory && this.topicsUsingCategory.length > 0) {
              Messenger.vent.trigger(
                "show:modal",
                TopicsUsingCategoryModalModule,
                {
                  categoryModel: args.model,
                },
                this.topicsUsingCategory,
                {
                  title: "admin.categories.category.topicsUsingCategoryList.title",
                  closeOnBackgroundClick: false,
                  modalWidth: "900px",
                  modalHeight: "600px",
                  trackInteraction: {
                    action: "Topics Using Category",
                    id: args.model.id,
                    idType: "Category",
                    object: "Category",
                  },
                },
              );
            } else {
              // there are no topics using this category code.
              // Open a message dialog and ask user to confirm deletion of category
              Messenger.yesNoDialog(
                "admin.categories.deleteCategory",
                {
                  yes: function () {
                    Messenger.vent.trigger("track:interaction", {
                      action: "Delete Category",
                      id: args.model.id,
                      idType: "Category",
                      object: "Category",
                    });
                    Messenger.vent.trigger("cancel:textbox"); //cancel any open textboxes
                    Messenger.vent.trigger("delete:category", args.model); //bubble up event
                  },
                },
                this,
              );
            }
          });
        },
        this,
      );

      this.layout.on(
        "show",
        function () {
          if (!this.category.get("categoryName") || this.category.get("categoryName") === "") {
            this._showCategoryNameAndDescription();
          } else {
            this._showSubViews();
          }
        },
        this,
      );

      this.showRegion(this.layout);
    },
    _showSubViews: function () {
      if (this.selectedLanguageId === 0) {
        //default language selected, show default category name
        this.categoryName = this.addSubModule(
          new CategoryNameModule({ region: this.layout.categoryNameText }),
        );
        this.categoryName.show(this.category);
      }
      if (this.selectedLanguageId !== 0) {
        this.categoryNamesLocalized = this.addSubModule(
          new CategoryNamesLocalizedModule({ region: this.layout.categoryNameText }),
        );
        this.categoryNamesLocalized.show(this.category, this.selectedLanguage);
      }
      this.categoryDescription = this.addSubModule(
        new CategoryDescriptionModule({ region: this.layout.categoryDescriptionText }),
      );
      this.categoryDescription.show(this.category);
    },
    _showCategoryNameAndDescription: function () {
      //categoryName is not valid, do not change to category name localized view. Show default locale category name
      this.categoryName = this.addSubModule(
        new CategoryNameModule({ region: this.layout.categoryNameText }),
      );
      this.categoryName.show(this.category);
      this.categoryDescription = this.addSubModule(
        new CategoryDescriptionModule({ region: this.layout.categoryDescriptionText }),
      );
      this.categoryDescription.show(this.category);
    },
    changeModule: function (selectedLanguage) {
      this.selectedLanguage = selectedLanguage;
      this.selectedLanguageId = selectedLanguage.get("id");
      this.category.selectedLanguage = this.selectedLanguage;
      this.category.selectedLanguageId = this.selectedLanguageId;
      this._showSubViews();
    },
    nameError: function (errorMessage) {
      this.layout.nameError(errorMessage);
    },
  });
});
